angular.module('tf.controllers')

    .controller('SignupControllerDep', function ($scope, $rootScope, AuthService,Session, $state, $timeout, $stateParams, AuthAlertService, $cookies, NotificationService, $http, RecaptchaService) {

        $scope.disableButton = false;
        $scope.credentials = {
            email: '',
            password: ''
        };
        $scope.referer = $stateParams.referer;


        $scope.signup = function (credentials) {
            AuthService.signup(credentials);
        };

        RecaptchaService.render('signup-recaptcha', function(token){
            $scope.credentials['g-recaptcha-response'] = token;
            $scope.signup($scope.credentials);
        });

        if($scope.referer && $scope.referer.email){
            $scope.credentials.email = $scope.referer.email;
            $scope.credentials.confirmEmail = $scope.credentials.email;
            $scope.emailPreset = true;
        }
        $scope.$on("login-info", function(event, data){
            $scope.showAlert(data);
        });
        $scope.$on("login-error", function(event, data){
            $scope.showAlert(data);
        });
        $scope.$on("signup-error", function(event, data){
            $scope.showAlert(data);
        });
        $scope.showAlert = function(alert){
            $timeout(function(){alert.show();},1);
        };

        (function handleInit(){
            var emailFromCookie = $cookies.get('user_email');
            if(emailFromCookie && $state.params.tfref){
                $scope.credentials.email = emailFromCookie;
                $scope.emailPreset = true;
            }
        })();

    })
;
